<template>
  <div class="book-list-container">
    <div class="book-list">
      <div
        class="book-list__item"
        :class="{
        'book-list__item--selected': selected(book),
        'book-list__item--learning': learning(book),
      }"
        v-for="book in currentPageList"
        :key="book.id"
        :id="book.id"
        :title="book.name"
        @click="onClick(book)"
        @dblclick="onDoubleClick(book)"
      >
        <span>{{book.name}}</span>
      </div>
    </div>
    <van-pagination
      v-if="list.length > pageSize"
      layout="prev, pager, next"
      :page-size="pageSize"
      :total="list.length"
      @current-change="onPageChange"
    />
  </div>
</template>

<script>
import { Pagination } from 'element-ui';

export default {
  components: {
    VanPagination: Pagination,
  },
  props: {
    list: {
      type: Array,
      default() {
        return [];
      },
    },
    // 是否选中
    selected: {
      type: Function,
      default() {
        return false;
      },
    },
    // 是否学习中 (近期学习)
    learning: {
      type: Function,
      default() {
        return false;
      },
    },
    pageSize: {
      type: Number,
      default: 20,
    },
  },
  data() {
    return {
      pageNumber: 1,
    };
  },
  computed: {
    currentPageList() {
      const startPos = (this.pageNumber - 1) * this.pageSize;
      const endPos = startPos + this.pageSize;
      return this.list.slice(startPos, endPos);
    },
  },
  watch: {
    list() {
      this.pageNumber = 1;
    },
  },
  methods: {
    onClick(book) {
      this.$emit('click', book);
    },
    onDoubleClick(book) {
      this.$emit('dbclick', book);
    },
    onPageChange(pageNumber) {
      this.pageNumber = pageNumber;
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '@/styles/variables.scss';

  .book-list-container {
    border-bottom: 2px solid #f2f2f2;
    .book-list {
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start;
      .book-list__item {
        position: relative;
        box-sizing: border-box;
        width: 240px;
        height: 64px;
        padding: 0 5px;
        line-height: 64px;
        margin-right: 20px;
        margin-bottom: 20px;
        border: 1px solid #f2f2f2;
        border-radius: 3px;
        font-size: 16px;
        box-shadow: 2px 2px 5px #ccc;
        background: #f9f9f9;
        text-align: center;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        cursor: pointer;
        &:hover {
          box-shadow: 0 0 10px #3f9eff;
          border-color: #a9d2fb;
        }
        &.book-list__item--selected {
          background: #eaf4ff;
          border-width: 2px;
          border-color: $primary;
          box-shadow: 2px 2px 5px #8cb8e4;
          &:hover {
            box-shadow: 0 0 10px #3f9eff;
            border-color: $primary;
          }
        }
        &.book-list__item--learning {
          border-right: 0;
          &:after {
            position: absolute;
            top: -16px;
            right: -42px;
            width: 100px;
            text-align: center;
            height: 50px;
            line-height: 80px;
            font-size: 12px;
            color: #fff;
            background-color: $primary;
            border-right: 0 !important;
            transform: rotate(45deg);
            content: '近期学习';
          }
        }
      }
    }
    .el-pagination {
      text-align: left;
      margin: 12px 0;
    }
  }
</style>
